<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Fixed Deposits</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <AllFixedDepositsTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * View Fixed Deposit Component
 */

import Layout from "../../../router/layouts/main";
import PageHeader from "../../../components/AppComponents/page-header";
import AllFixedDepositsTable from "@/components/Kleyton/Tables/Investment/FIxedDeposit/AllFixedDepositsTable";

export default {
  page: {
    title: "Fixed Deposits",
    meta: [{ name: "Fixed Deposits", content: window.__env.app.description }]
  },
  components: {
    AllFixedDepositsTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Fixed Deposits",

      items: [
        {
          text: "Investment",
          href: "/"
        },
        {
          text: "Fixed Deposits",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
